<div class="nd-panel">

  <!-- Header -->
  <div class="nd-header">
    <div class="nd-header-top">
      <div class="nd-title">
        <i class="ti ti-bell"></i>
        <span>Notifications</span>
        @if (unreadCount > 0) {
          <span class="nd-count-badge">{{ unreadCount }}</span>
        }
      </div>
      @if (unreadCount > 0) {
        <button class="nd-mark-all" (click)="markAllRead()">Mark all read</button>
      }
    </div>

    <!-- Tabs -->
    <div class="nd-tabs">
      <button class="nd-tab" [class.active]="tab === 'all'" (click)="switchTab('all')">All</button>
      <button class="nd-tab" [class.active]="tab === 'unread'" (click)="switchTab('unread')">
        Unread
        @if (unreadCount > 0) { <span class="nd-tab-dot"></span> }
      </button>
    </div>
  </div>

  <!-- List -->
  <div class="nd-list" (scroll)="onScroll($event)">

    @if (loading) {
      <div class="nd-loading">
        <span class="nd-spinner"></span>
      </div>
    } @else if (notifications.length === 0) {
      <div class="nd-empty">
        <i class="ti ti-bell-off"></i>
        <span>No notifications</span>
      </div>
    } @else {
      @for (n of notifications; track (n._id ?? n.date_created_utc)) {
        @let ic = getIcon(n.notificationType);
        <div class="nd-item" [class.nd-item--unread]="!n.is_read" (click)="markRead(n)">

          <!-- Icon -->
          <div class="nd-avatar-wrap">
            <div class="nd-icon-avatar" [ngClass]="ic.bg">
              <i [class]="ic.icon"></i>
            </div>
            @if (!n.is_read) { <span class="nd-unread-dot"></span> }
          </div>

          <!-- Content -->
          <div class="nd-content">
            <div class="nd-content-top">
              <span class="nd-name">{{ n.title }}</span>
              <span class="nd-time">{{ n.date_created_utc | localTime:'D MMM, h:mm A' }}</span>
            </div>
            <p class="nd-text">{{ n.body }}</p>
          </div>

        </div>
      }

      @if (loadingMore) {
        <div class="nd-load-more">
          <span class="nd-spinner nd-spinner--sm"></span>
        </div>
      }
    }

  </div>

</div>
